export const BAR_CHART_COLORS = [
  '#163153',
  '#4698cb',
  '#337079',
  '#74d2e7',
  '#635596',
  '#cf026f',
  '#ad97dc',
]
export const PIE_CHART_COLORS = [
  '#003d6d',
  '#d0006f',
  '#006298',
  '#337079',
  '#74d2e7',
  '#635596',
  '#ad96dc',
  '#84344e',
  '#97999b',
  '#4698cb',
  '#aeb862',
]
export const PIE_COLORS = {
  PIE_COLOR_PRIMARY: 'rgb(15, 54, 78)',
  PIE_COLOR_OTHER: 'rgba(35, 31, 32, 0.2)',
  PIE_BG_COLOR: 'rgba(255,255,255, 0.95)',
  PIE_BORDER_COLOR: 'rgba(35, 31, 32, 0.3)',
}
export const BAR_COLORS = [
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
  'brown',
  'teal',
  'fuscia',
]
export const GROUP_TYPE_ETF = 'Retail ETF'
export const GROUP_TYPE_MUTUAL_FUNDS = 'Retail'
export const OTHER_LABEL = 'Other'
